module.exports = __webpack_public_path__ + "media/images/pic/hero/desc-2d273bedeeba4a5af769a417ab92d6cd.svg";